import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';
import { combineBonuses, sections, unwrapBonusResponse } from './bonusSections';

const commonGet = () => ({ url: '/data/mentor-me-bonus/', method: 'GET', cache: 'no-store' });

export const bonusesApi = createApi({
    baseQuery,
    reducerPath: 'bonusesApi',
    endpoints: (builder) => ({
        getBonuses: builder.query({
            query: commonGet,
            transformResponse: (response) => combineBonuses(unwrapBonusResponse(response)),
        }),
        updateBonuses: builder.mutation({
            async queryFn(data, api, extraOptions) {
                const posted = await baseQuery({
                    url: '/admin/site/mentor-me-bonus/', method: 'POST', body: data,
                }, api, extraOptions);
                if (posted.error) return { error: posted.error };

                const loaded = await baseQuery(commonGet(), api, extraOptions);
                if (loaded.error) return { error: {
                    status: 'CUSTOM_ERROR',
                    error: 'Could not verify saved bonuses.',
                    data: { message: 'Save request completed, but saved bonuses could not be reloaded. Please retry Refresh.' },
                } };

                const saved = unwrapBonusResponse(loaded.data);
                if (!sections.every(({ key }) => saved?.[key] && typeof saved[key] === 'object' && !Array.isArray(saved[key]))) {
                    return { error: {
                        status: 'CUSTOM_ERROR',
                        error: 'The common GET did not return all three sections.',
                        data: { message: 'Save request completed, but the backend did not return all three sections. Please check the common GET/POST storage.' },
                    } };
                }
                return { data: saved };
            },
        }),
    }),
});

export const { useGetBonusesQuery, useUpdateBonusesMutation } = bonusesApi;
